/**
 * The whole of the theme's JavaScript.
 *
 * Two behaviours, and both are enhancements over markup that already works:
 * the filter form submits itself when something changes, and the cart's remove
 * links do not need a page they are already on. Everything else — search,
 * pagination, add to cart, checkout — is a plain form or a plain link, which is
 * the right default for a shop whose customers are frequently on a phone with
 * two bars on a train.
 */

(function () {
  "use strict";

  /*
   * Auto-applying facets.
   *
   * The form has a real submit button rendered inside <noscript>, so a browser
   * with no script gets an Apply button and a browser with script gets neither
   * the button nor the click. Debounced, because the price inputs fire on every
   * keystroke and each apply is a page load.
   */
  var facets = document.getElementById("facet-form");
  if (facets) {
    var timer = null;
    var apply = function (wait) {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        facets.submit();
      }, wait);
    };

    facets.addEventListener("change", function (event) {
      // A checkbox is a decision; a number is still being typed.
      apply(event.target.type === "number" ? 600 : 0);
    });
    facets.addEventListener("input", function (event) {
      if (event.target.type === "number") apply(700);
    });
  }

  /*
   * Announcing the cart count to a screen reader after an add.
   *
   * The add-to-cart form is a normal POST that navigates, so there is nothing
   * to intercept — this only matters for the back-forward cache, where Safari
   * restores the page with a stale header. Asking the cart for its real count
   * on `pageshow` is cheaper than disabling the cache.
   */
  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;
    fetch(window.Shopify ? "/cart.js" : "/cart.js", { headers: { accept: "application/json" } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        var badge = document.querySelector(".cart-count");
        var link = document.querySelector(".cart-link");
        if (cart.item_count > 0) {
          if (badge) {
            badge.textContent = String(cart.item_count);
          } else if (link) {
            var span = document.createElement("span");
            span.className = "cart-count";
            span.textContent = String(cart.item_count);
            link.appendChild(span);
          }
        } else if (badge) {
          badge.remove();
        }
      })
      .catch(function () {
        /* A stale count is not worth an error anybody sees. */
      });
  });
})();
